import { render, staticRenderFns } from "./GoogleAd.vue?vue&type=template&id=4bbb0476&"
import script from "./GoogleAd.vue?vue&type=script&lang=ts&"
export * from "./GoogleAd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports